module.exports = __webpack_public_path__ + "img/agavecorte-historia.0fe2ce9e.jpg";